import { DataCache, DataCacheCollection, QueryResultsRelationship } from 'lib/DataCache';
import { PCCache } from 'data/PCCache';
import { OrganizationsResponse } from 'data/models/OrganizationsResponse';

export class OrganizationsCache extends DataCache {
    // The OrganizationsController doesn't take any parameters. Use a dummy key to force this to be a singleton.
    OrganizationsResponses = new DataCacheCollection(OrganizationsResponse, OrganizationsResponse.update, r => 1, r => 1);

    constructor(data : PCCache) {
        super();
        new QueryResultsRelationship(this.OrganizationsResponses, data.Organizations, r => r.Organizations);
    }
}


// WEBPACK FOOTER //
// ./apps/portcall/organizations/cache.ts